import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { BrowserDetectUtil } from 'sharedGuiSmall/utils/browser-detect-util';
import {  DomSmallUtils  } from 'sharedGuiSmall/utils/dom-utils';
import { LayoutSmallUtil } from 'sharedGuiSmall/utils/layout-util';
import { BaseSmallComponent } from 'sharedGuiSmall/base/base-component';

@Component({
    selector: 'simple-btn',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent extends BaseSmallComponent implements OnChanges {

    @Input()
    text: string = $localize`Button`;

    @Input()
    testid: string = '';

    @Input()
    height: number | undefined;

    @Input()
    width: number | undefined;

    @Input()
    leftImgCls: string = '';

    @Input()
    leftImgHoverCls: string = '';

    @Input()
    rightImgCls: string = '';

    @Input()
    rightImgHoverCls: string = '';

    @Input()
    ignoreLeftSpace = false;

    //todo something with this input that make it works with ignoreLeftSpace
    @Input()
    leftSpace: number = 10;

    @Input()
    rightSpace: number = 10;

    @Input()
    cornerRadius: number = 10;

    @ViewChild('main')
    main!: ElementRef;

    @ViewChild('textEl')
    textEl!: ElementRef;

    @ViewChild('leftImg')
    leftImg: ElementRef | undefined;

    @ViewChild('rightImg')
    rightImg: ElementRef<HTMLDivElement> | undefined;

    @ViewChild('btncontent')
    btnContent: ElementRef | undefined;

    @Input()
    backgroundFill: string = '';

    @Input()
    hoverFill: string = '';

    @Input()
    textColor: string = 'white';

    @Input()
    hoverTextColor: string = '';

    @Input()
    borderWidth: number | undefined;

    @Input()
    borderColor: string = 'black';

    @Input()
    hoverBorderColor: string = '';


    @Input()
    backgroundFillCls: string = '';

    @Input()
    hoverFillCls: string = '';

    @Input()
    textColorCls: string = '';

    @Input()
    hoverTextColorCls: string = '';

    @Input()
    borderColorCls: string = '';

    @Input()
    hoverBorderColorCls: string = '';

    @Input()
    textCls: string = "h5Font";

    @Input()
    fontSize: string = '';

    @Input()
    fontWeight: string = '';

    @Input()
    fontFamily: string = '';

    @Input()
    disabled: boolean = false;

    @Input()
    horizontalPadding: number = 0;

    @Input()
    rightRadius: string = "";

    @Input()
    leftRadius: string = "";

    @Input()
    boxShadowCls: string = '';

    @Input()
    hoverDisabled: boolean = false;

    //state
    hovered: string = 'nothovered';

    private isViewInitialized: boolean = false;

    clickEvent: EventEmitter<any>;

    isIe: boolean = false;

    private currentComponentRect: DOMRect | undefined;

    protected boxShadow: string = '';

    constructor(element: ElementRef,
        renderer: Renderer2,
        protected chDet: ChangeDetectorRef
    ) {
        super(element, renderer);

        this.clickEvent = new EventEmitter();
        this.isIe = BrowserDetectUtil.isIe();
    }

    ngOnChanges(changes: SimpleChanges) {

        this.handleDisabled();
        if (changes["text"] && !changes["text"].firstChange)
            this.update();
    }

    protected ngAfterViewInit(): void {

        if (BrowserDetectUtil.isSafari()) setTimeout(() => { this.activateChanges(); this.isViewInitialized = true; }, 0);
        else {
            this.activateChanges();
            this.isViewInitialized = true;
        }
    }

    private doLayout(): void {

        if (!this.isViewInitialized) return;

        let width = this.width;
        let height = this.height;

        this.r.setStyle(this.main.nativeElement, "padding-left", this.horizontalPadding + 'px');
        this.r.setStyle(this.main.nativeElement, "padding-right", this.horizontalPadding + 'px');

        if (this.leftImg && !this.ignoreLeftSpace) {
            //todo identical code blocks
            if (!this.isIe) this.r.setStyle(this.textEl.nativeElement, "marginLeft", this.leftSpace + 'px');
            else this.r.setStyle(this.textEl.nativeElement, "paddingLeft", this.leftSpace + 'px');
        }
        if (this.rightImg) {
            //todo identical code blocks
            if (!this.isIe) this.r.setStyle(this.rightImg.nativeElement, "marginLeft", this.rightSpace + 'px');
            else this.r.setStyle(this.rightImg.nativeElement, "paddingLeft", this.rightSpace + 'px');
        }
        if (this.horizontalPadding) {
            const btnOffsetWidth = this.btnContent ? this.btnContent.nativeElement.offsetWidth : 0;
            width = btnOffsetWidth + 2 * this.horizontalPadding;
        }

        this.r.setStyle(this.main.nativeElement, "width", '');
        this.r.setStyle(this.main.nativeElement, "height", '');

        if (!width) width = DomSmallUtils.outerWidth(this.getElDom());
        else this.r.setStyle(this.getElDom(), "width", width + 'px');

        if (!height) height = DomSmallUtils.outerHeight(this.getElDom());
        else this.r.setStyle(this.getElDom(), "height", height + 'px');

        this.r.setStyle(this.main.nativeElement, "width", width + 'px');
        this.r.setStyle(this.main.nativeElement, "height", height + 'px');
    }

    protected ngAfterViewChecked(): void {

        if (!this.isViewInitialized) return;

        let newComponentRect = this.getElDom().getBoundingClientRect();
        if (!LayoutSmallUtil.isRectsSizeSame(this.currentComponentRect, newComponentRect)) this.doLayout();

        this.currentComponentRect = newComponentRect;
    }

    ngAfterContentChecked() {
        if (this.rightImgCls && this.rightImg && getComputedStyle(this.rightImg.nativeElement).width == "0px")
            this.setRightImageSizes();
        if (this.leftImgCls && this.leftImg && getComputedStyle(this.leftImg.nativeElement).width == "0px")
            this.setLeftImageSizes();
    }

    protected update() {
        this.chDet.detectChanges();
        this.doLayout();
    }

    protected resetHoverStyles(): void {

        this.hoverFill = '';

        this.hoverTextColor = '';

        this.hoverBorderColor = '';

        this.leftImgHoverCls = '';

        this.rightImgHoverCls = '';
    }

    protected activateChanges() {

        if (!this.hoverFill) this.hoverFill = this.backgroundFill;

        if (!this.hoverTextColor) this.hoverTextColor = this.textColor;

        if (!this.hoverBorderColor) this.hoverBorderColor = this.borderColor;

        if (!this.leftImgHoverCls && this.leftImgCls) this.leftImgHoverCls = this.leftImgCls;

        if (!this.rightImgHoverCls && this.rightImgCls) this.rightImgHoverCls = this.rightImgCls;

        if (this.borderWidth) {
            if (this.borderColorCls) {
                this.r.setStyle(this.main.nativeElement, "border-width", this.borderWidth + 'px');
                this.r.setStyle(this.main.nativeElement, "border-style", 'solid');
                this.r.addClass(this.main.nativeElement, this.borderColorCls);
            }
            else this.r.setStyle(this.main.nativeElement, "border", this.borderWidth + 'px solid ' + this.borderColor);
        }
        else {
            if (this.borderColorCls) this.r.removeClass(this.main.nativeElement, this.borderColorCls);
            else this.r.removeStyle(this.main.nativeElement, 'border');
        }

        if (this.leftImgCls && this.leftImg) {
            this.setLeftImageSizes();
        }

        if (this.rightImgCls && this.rightImg) {
            this.setRightImageSizes();
        }

        this.r.setStyle(this.getElDom(), "display", 'flex');


        if (!this.rightRadius && !this.leftRadius) {
            this.r.setStyle(this.main.nativeElement, "borderRadius", this.cornerRadius + 'px');
            this.r.setStyle(this.getElDom(), "borderRadius", this.cornerRadius + 'px');
        }
        else {
            if (!!this.leftRadius) {

                this.r.setStyle(this.main.nativeElement, "border-top-left-radius", this.leftRadius + 'px');
                this.r.setStyle(this.main.nativeElement, "border-bottom-left-radius", this.leftRadius + 'px');

                this.r.setStyle(this.getElDom(), "border-top-left-radius", this.leftRadius + 'px');
                this.r.setStyle(this.getElDom(), "border-bottom-left-radius", this.leftRadius + 'px');
            }
            if (!!this.rightRadius) {

                this.r.setStyle(this.main.nativeElement, "border-top-right-radius", this.rightRadius + 'px');
                this.r.setStyle(this.main.nativeElement, "border-bottom-right-radius", this.rightRadius + 'px');
                this.r.setStyle(this.getElDom(), "border-top-right-radius", this.rightRadius + 'px');
                this.r.setStyle(this.getElDom(), "border-bottom-right-radius", this.rightRadius + 'px');
            }
        }

        if (this.leftImg && !this.ignoreLeftSpace) {
            //todo identical code blocks
            if (!this.isIe) this.r.setStyle(this.textEl.nativeElement, "marginLeft", this.leftSpace + 'px');
            else this.r.setStyle(this.textEl.nativeElement, "paddingLeft", this.leftSpace + 'px');
        }
        if (this.rightImg) {
            //todo identical code blocks
            if (!this.isIe) this.r.setStyle(this.rightImg.nativeElement, "marginLeft", this.rightSpace + 'px');
            else this.r.setStyle(this.rightImg.nativeElement, "paddingLeft", this.rightSpace + 'px');
        }

        if (this.width) this.horizontalPadding = 0;

        this.r.setStyle(this.main.nativeElement, "padding-left", this.horizontalPadding + 'px');
        this.r.setStyle(this.main.nativeElement, "padding-right", this.horizontalPadding + 'px');

        let width = this.width;
        let height = this.height;

        if (this.horizontalPadding) {
            const btnOffsetWidth = this.btnContent ? this.btnContent.nativeElement.offsetWidth : 0;
            width = btnOffsetWidth + 2 * this.horizontalPadding;
        }

        this.r.setStyle(this.main.nativeElement, "width", '');
        this.r.setStyle(this.main.nativeElement, "height", '');

        this.r.setStyle(this.main.nativeElement, "width", width + 'px');
        this.r.setStyle(this.main.nativeElement, "height", height + 'px');

        if (this.backgroundFillCls)
            this.r.addClass(this.main.nativeElement, this.backgroundFillCls);
        else
            this.r.setStyle(this.main.nativeElement, "backgroundColor", this.backgroundFill);

        if (this.backgroundFillCls)
            this.r.addClass(this.getElDom(), this.backgroundFillCls);
        else
            this.r.setStyle(this.getElDom(), "backgroundColor", this.backgroundFill);

        if (this.textColorCls)
            this.r.addClass(this.textEl.nativeElement, this.textColorCls);
        else
            this.r.setStyle(this.textEl.nativeElement, "color", this.textColor);

        if (this.boxShadowCls)
            this.r.addClass(this.getElDom(), this.boxShadowCls);

        if (this.boxShadow)
            this.r.setStyle(this.getElDom(), 'box-shadow', this.boxShadow);
        else
            this.r.removeStyle(this.getElDom(), 'box-shadow');

        this.handleDisabled();
    }

    protected handleDisabled() {
        // TODO: check why main may be is null here (click calendar on timeline)
        if (!this.main) return;

        if (this.disabled) {

            if (this.backgroundFillCls)
                this.r.addClass(this.main.nativeElement, this.backgroundFillCls);
            else
                this.r.setStyle(this.main.nativeElement, 'backgroundColor', this.backgroundFill);

            if (this.borderColorCls)
                this.r.addClass(this.main.nativeElement, this.borderColorCls);
            else
                this.r.setStyle(this.main.nativeElement, 'borderColor', this.borderColor);

            if (this.textColorCls)
                this.r.addClass(this.textEl.nativeElement, this.textColorCls);
            else
                this.r.setStyle(this.textEl.nativeElement, "color", this.textColor);

            this.r.setStyle(this.getElDom(), "opacity", 0.3);
            this.r.setStyle(this.getElDom(), "pointer-events", 'none');
        }
        else {
            this.r.setStyle(this.getElDom(), "opacity", 1);
            this.r.setStyle(this.getElDom(), "pointer-events", '');
        }
    }

    mouseIn(): void {
        if (this.hoverDisabled) return;

        if (this.disabled) return;

        if (this.hoverFillCls) {
            this.r.removeClass(this.main.nativeElement, this.backgroundFillCls);
            this.r.addClass(this.main.nativeElement, this.hoverFillCls);
        }
        else {
            this.r.setStyle(this.main.nativeElement, 'background-color', this.hoverFill);
        }

        if (this.hoverBorderColorCls) {
            this.r.removeClass(this.main.nativeElement, this.borderColorCls);
            this.r.addClass(this.main.nativeElement, this.hoverBorderColorCls);
        }
        else {
            this.r.setStyle(this.main.nativeElement, 'border-color', this.hoverBorderColor);
        }

        if (this.hoverTextColorCls) {
            this.r.removeClass(this.textEl.nativeElement, this.textColorCls);
            this.r.addClass(this.textEl.nativeElement, this.hoverTextColorCls);
        }
        else {
            this.r.setStyle(this.textEl.nativeElement, 'color', this.hoverTextColor);
        }

        if (this.leftImg) {
            const leftImgEl: HTMLElement = this.leftImg.nativeElement;
            const leftImgSecondDiv: HTMLElement = leftImgEl.children[1] as HTMLElement;

            if (leftImgSecondDiv)
                this.r.setStyle(leftImgSecondDiv, 'opacity', '1');
        }

        if (this.rightImg) {
            const rightImgEl: HTMLElement = this.rightImg.nativeElement;
            const rightImgSecondDiv: HTMLElement = rightImgEl.children[1] as HTMLElement;

            if (rightImgSecondDiv)
                this.r.setStyle(rightImgSecondDiv, 'opacity', '1');
        }
    }

    mouseOut(): void {
        const mainElem: HTMLElement = this.main.nativeElement;
        const textElem: HTMLElement = this.textEl.nativeElement;

        let leftImgEl!: HTMLElement;
        let rightImgEl!: HTMLElement;

        if (this.leftImg) {
            let elem: HTMLElement = this.leftImg.nativeElement;

            if (elem && elem.children.length > 1)
                leftImgEl = elem.children[1] as HTMLElement;
        }

        if (this.rightImg) {
            let elem: HTMLElement = this.rightImg.nativeElement;

            if (elem && elem.children.length > 1)
                rightImgEl = elem.children[1] as HTMLElement;
        }

        if (this.hoverDisabled) return;

        if (this.disabled) return;

        if (this.hoverFillCls) {
            this.r.removeClass(mainElem, this.hoverFillCls);
            this.r.addClass(mainElem, this.backgroundFillCls);
        }
        else this.r.setStyle(mainElem, 'background-color', this.backgroundFill);

        if (this.hoverBorderColorCls) {
            this.r.removeClass(mainElem, this.hoverBorderColorCls);
            this.r.addClass(mainElem, this.borderColorCls);
        }
        else this.r.setStyle(mainElem, 'border-color', this.borderColor);

        if (this.hoverTextColorCls) {
            this.r.removeClass(textElem, this.hoverTextColorCls);
            this.r.addClass(textElem, this.textColorCls);
        }
        else this.r.setStyle(textElem, 'color', this.textColor);

        if (leftImgEl)
            this.r.setStyle(leftImgEl, 'opacity', '0');

        if (rightImgEl)
            this.r.setStyle(rightImgEl, 'opacity', '0');
    }

    public enable(): void {
        // TODO: check why main may be is null here (click calendar on timeline)
        if (!this.main) return;

        this.disabled = false;
        //this.r.setStyle(this.main.nativeElement, "opacity", 1);
        this.r.setStyle(this.getElDom(), "opacity", 1);
        this.r.setStyle(this.getElDom(), "pointer-events", '');
    }

    public disable(): void {
        // TODO: check why main may be is null here (click calendar on timeline)
        if (!this.main) return;

        this.disabled = true;
        //this.r.setStyle(this.main.nativeElement, "opacity", 0.3);

        if (this.hoverFillCls) {
            this.r.removeClass(this.main.nativeElement, this.hoverFillCls);
            this.r.addClass(this.main.nativeElement, this.backgroundFillCls);
        }
        else this.r.setStyle(this.main.nativeElement, 'backgroundColor', this.backgroundFill);

        if (this.hoverBorderColorCls) {

            this.r.removeClass(this.main.nativeElement, this.hoverBorderColorCls);
            this.r.addClass(this.main.nativeElement, this.borderColorCls);
        }
        else this.r.setStyle(this.main.nativeElement, 'borderColor', this.borderColor);

        this.r.setStyle(this.getElDom(), "opacity", 0.3);
        this.r.setStyle(this.getElDom(), "pointer-events", 'none');
    }

    public disableHover(disable: boolean): void {

        if (disable) this.hoverDisabled = true;
        else this.hoverDisabled = false;
    }

    public setText(txt: string): void {

        this.text = txt;
    }

    public setBackgroundFillCls(backgroundFill: string): void {

        this.r.removeClass(this.getElDom(), this.backgroundFillCls);
        this.r.removeClass(this.main.nativeElement, this.backgroundFillCls);
        this.backgroundFillCls = backgroundFill;
        this.r.addClass(this.getElDom(), this.backgroundFillCls);
        this.r.addClass(this.main.nativeElement, this.backgroundFillCls);
    }

    public setTextColorCls(textColor: string): void {
        this.r.removeClass(this.textEl.nativeElement, this.textColorCls);
        this.textColorCls = textColor;
        this.r.addClass(this.textEl.nativeElement, this.textColorCls);
    }

    public setBorderColorCls(borderColor: string): void {
        this.r.removeClass(this.main.nativeElement, this.borderColorCls);
        this.borderColorCls = borderColor;
        this.r.addClass(this.main.nativeElement, this.borderColorCls);
    }

    private setRightImageSizes() {
        if (!this.rightImg)
            return;
        const rightImgEl: HTMLElement = this.rightImg.nativeElement;
        const rightImgFirstChildEl: HTMLElement = rightImgEl.children[0] as HTMLElement;
        this.r.setStyle(rightImgEl, 'width', DomSmallUtils.width(rightImgFirstChildEl) + 'px');
        this.r.setStyle(rightImgEl, 'height', DomSmallUtils.height(rightImgFirstChildEl) + 'px');
    }

    private setLeftImageSizes() {
        if (!this.leftImg)
            return;
        const leftImgEl: HTMLElement = this.leftImg.nativeElement;
        const leftImgFirstChildEl: HTMLElement = leftImgEl.children[0] as HTMLElement;

        this.r.setStyle(leftImgEl, 'width', DomSmallUtils.width(leftImgFirstChildEl) + 'px');
        this.r.setStyle(leftImgEl, 'height', DomSmallUtils.height(leftImgFirstChildEl) + 'px');
    }
}
